import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetEmspUsersInvoicesPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.form-default-values';
import { GetEmspUsersInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoInvoiceListContextProvider,
  useEmspBoInvoiceListContext,
} from '../emsp-bo-invoice.context';
import { EmspBoInvoiceListFilterFormController } from './emsp-bo-invoice-list-filter-form/emsp-bo-invoice-list-filter-form.controller';

interface EmspBoInvoiceListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoInvoiceListFilterController = ({
  onCancel,
  onSuccess,
}: EmspBoInvoiceListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoInvoiceListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetEmspUsersInvoicesPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-invoice-list-filter.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetEmspUsersInvoicesPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      status: fieldValues.status,
      type: fieldValues.type,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetEmspUsersInvoicesPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterEmspBoInvoiceListContextProvider data={data}>
      <EmspBoInvoiceListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterEmspBoInvoiceListContextProvider>
  );
};
